import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/icons/active.svg'
import _imports_1 from '@/assets/icons/idle.svg'
import _imports_2 from '@/assets/icons/openlistdetails.svg'
import _imports_3 from '@/assets/icons/pagefirstenabled.svg'
import _imports_4 from '@/assets/icons/pagefirstdisabled.svg'
import _imports_5 from '@/assets/icons/pagelastenabled.svg'
import _imports_6 from '@/assets/icons/pagelastdisabled.svg'


const _hoisted_1 = { class: "borrowcell" }
const _hoisted_2 = {
  key: 0,
  src: _imports_0,
  style: {"width":"20px"},
  alt: "activeimg",
  title: "activeimg"
}
const _hoisted_3 = {
  key: 1,
  src: _imports_1,
  style: {"width":"20px"},
  alt: "idleimg",
  title: "idleimg"
}
const _hoisted_4 = { style: {"margin-left":"5px"} }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  style: {"width":"25px"},
  alt: "listdetailsimg",
  title: "listdetailsimg"
}, null, -1)
const _hoisted_6 = {
  key: 0,
  class: "pagingdiv"
}
const _hoisted_7 = { class: "pagelabel" }
const _hoisted_8 = {
  key: 0,
  src: _imports_3,
  style: {"width":"20px"},
  alt: "pagefirstenabledimg",
  title: "pagefirstenabledimg"
}
const _hoisted_9 = {
  key: 1,
  src: _imports_4,
  style: {"width":"20px"},
  alt: "pagefirstdisabledimg",
  title: "pagefirstdisabledimg"
}
const _hoisted_10 = {
  key: 0,
  src: _imports_5,
  style: {"width":"20px"},
  alt: "pagelastenabledimg",
  title: "pagelastenabledimg"
}
const _hoisted_11 = {
  key: 1,
  src: _imports_6,
  style: {"width":"20px"},
  alt: "pagelastdisabledimg",
  title: "pagelastdisabledimg"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserOptions = _resolveComponent("UserOptions")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_UserOptions, {
      sortField: _ctx.sorttingField,
      sortOrder: _ctx.sortOrder
    }, null, 8, ["sortField", "sortOrder"]),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      ref: "usersTableRef",
      id: "userslisttable",
      data: _ctx.userList,
      style: {"width":"100%"},
      "max-height": "600px",
      "scrollbar-always-on": "",
      "row-key": "userBucketId",
      "header-cell-style": _ctx.headerstyle,
      "row-style": _ctx.rowdatastyle,
      onSelectionChange: _ctx.handleSelectionChange,
      onRowClick: _ctx.rowClickHandler,
      onSortChange: _ctx.handleSorting,
      "default-sort": { prop: 'name', order: 'aescending' },
      "empty-text": _ctx.nodatatxt
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          type: "selection",
          width: "55"
        }),
        _createVNode(_component_el_table_column, {
          label: "User Name",
          prop: "name",
          sortable: ""
        }),
        _createVNode(_component_el_table_column, {
          sortable: "",
          label: "Email",
          prop: "email"
        }),
        _createVNode(_component_el_table_column, {
          label: "Assigned Products",
          prop: "products"
        }, {
          default: _withCtx((props) => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.row.products, (prod, index) => {
              return (_openBlock(), _createElementBlock("div", { key: index }, _toDisplayString(prod.productName) + " " + _toDisplayString(prod.majorVersionNumber) + "." + _toDisplayString(prod.minorVersionNumber), 1))
            }), 128))
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "Assigned Add-ons",
          align: "center",
          prop: "addOns"
        }, {
          default: _withCtx((props) => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.row.addOns, (addon, index) => {
              return (_openBlock(), _createElementBlock("div", { key: index }, _toDisplayString(addon.productName) + " " + _toDisplayString(addon.majorVersionNumber) + "." + _toDisplayString(addon.minorVersionNumber), 1))
            }), 128))
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "Application Status",
          align: "center",
          prop: "userStatus"
        }, {
          default: _withCtx((user) => [
            _createElementVNode("div", _hoisted_1, [
              (user.row.userStatus === 'Active')
                ? (_openBlock(), _createElementBlock("img", _hoisted_2))
                : _createCommentVNode("", true),
              (user.row.userStatus === 'Idle')
                ? (_openBlock(), _createElementBlock("img", _hoisted_3))
                : _createCommentVNode("", true),
              _createElementVNode("label", _hoisted_4, _toDisplayString(user.row.userStatus), 1)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          fixed: "right",
          label: "",
          width: "120"
        }, {
          default: _withCtx((user) => [
            _createVNode(_component_el_button, {
              onClick: ($event: any) => (_ctx.viewDetails(user.row)),
              plain: "",
              link: "",
              size: "small"
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data", "header-cell-style", "row-style", "onSelectionChange", "onRowClick", "onSortChange", "empty-text"])), [
      [_directive_loading, _ctx.loading]
    ]),
    (_ctx.totalPages > 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("label", _hoisted_7, [
            _createElementVNode("strong", null, "Page " + _toDisplayString(_ctx.currentPage) + " / " + _toDisplayString(_ctx.totalPages), 1)
          ]),
          _createVNode(_component_el_button, {
            plain: "",
            class: "paginationbtn",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.currentPage = 1)),
            id: "firstpage",
            disabled: _ctx.currentPage === 1
          }, {
            default: _withCtx(() => [
              (_ctx.currentPage !== 1)
                ? (_openBlock(), _createElementBlock("img", _hoisted_8))
                : _createCommentVNode("", true),
              (_ctx.currentPage === 1)
                ? (_openBlock(), _createElementBlock("img", _hoisted_9))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_component_el_pagination, {
            layout: "prev, next",
            total: _ctx.totalRowsCount,
            "page-size": 10,
            "current-page": _ctx.currentPage,
            "onUpdate:currentPage": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.currentPage) = $event))
          }, null, 8, ["total", "current-page"]),
          _createVNode(_component_el_button, {
            plain: "",
            class: "paginationbtn",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.currentPage = _ctx.totalPages)),
            id: "lastpage",
            disabled: _ctx.currentPage === _ctx.totalPages
          }, {
            default: _withCtx(() => [
              (_ctx.currentPage !== _ctx.totalPages)
                ? (_openBlock(), _createElementBlock("img", _hoisted_10))
                : _createCommentVNode("", true),
              (_ctx.currentPage === _ctx.totalPages)
                ? (_openBlock(), _createElementBlock("img", _hoisted_11))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["disabled"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}